import { getAPI , postAPI} from "../../api";
import { REACT_APP_TIMESHEET, REACT_APP_TIMESHEETPAYMENT } from "../../utils/common";

export async function getTimeSheetDetails(timesheetId : any, projectId : any){ 
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-details/${timesheetId}?projectId=${projectId}`)
    return Details
}

export async function approveTimeSheet(data: any){ 
    const Details = postAPI( REACT_APP_TIMESHEETPAYMENT + `/timesheet-approve`,data)
    return Details
}

export async function rejectTimeSheet(data: any){ 
    const Details = postAPI( REACT_APP_TIMESHEETPAYMENT + `/timesheet-reject`,data)
    return Details
}
